<template lang="pug">
  v-container
    Formulario_cotizacion(v-if='$route.params.idCotizacion')
    Interfaz_provedor(v-if='!$route.params.idCotizacion')
        
</template>
<script>  
  export default {
    components:{
      Formulario_cotizacion:()=>import('../../vistas/proveedor/Formulario_cotizacion'),
      Interfaz_provedor:()=>import('../../vistas/proveedor/Interfaz_provedor'),
    }
}
</script>
